import React from 'react';

export const Logo = (props) => {
  const mobile = window.screen.width < 1200;

  return (
    <div
      style={props.styleOverride}
      className="paymints__box-container__logo-container"
    >
      <img
        src={props.brandLogo}
        className="paymints__box-container__brand_logo"
        alt=""
        hidden={mobile}
      />
      <img
        src={props.brandLogo}
        className="paymints__box-container__brand_logo"
        alt=""
        hidden={!mobile}
      />
    </div>
  );
};
